"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoControls = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * VideoControls
 * 
 * An element that represents a group of video controls
 * 
 * @component 
 * @category Molecules
 */
var VideoControls = function VideoControls(props) {
  var className = props.className ? props.className : "";
  className += " VideoControls";
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({
    className: className
  }, props), props.children);
};

exports.VideoControls = VideoControls;